import { ProgressSpinner } from 'primereact/progressspinner';
export const Progressspinner = ({width = '50px',height = '50px'}) =>{
   return <div style={{display:'flex'}}><ProgressSpinner style={{width: width, height: height}} strokeWidth="8" fill="var(--surface-ground)" animationDuration=".5s" /> </div>
}


export const Progressspinnerimg = ({width = '300px',height = '50px'}) =>{
   return <div style={{display:'flex',justifyContent: 'center'}}>
           {/* <img src={loaderGif} alt="Loading animation" width={width}/> */}
           <ProgressSpinner style={{width: width, height: height}} strokeWidth="8" fill="var(--surface-ground)" animationDuration=".5s" /> 
      </div>
}


export const Overlayloader = ({width = '300px',height = '50px',isloaded = true}) =>{
   return (!isloaded ?  (<div style={{display:'flex',justifyContent: 'center'}}>
           <ProgressSpinner style={{width: width, height: height}} strokeWidth="8" fill="var(--surface-ground)" animationDuration=".5s" /> 
      </div>) : (<></>))
   
}


export const ButtonLoader = () =>{
   return (<div class="loader1"></div>); 
}


export const Loaderoverlay = ({isloaded}) =>{
   if(!isloaded){
       return (<div className='overlayloader'><div class="loader1"></div></div>);       
   }else{
       return <></>  
   }   
}